import { render, staticRenderFns } from "./Temu.vue?vue&type=template&id=6a313a7f&scoped=true"
import script from "./Temu.vue?vue&type=script&lang=js"
export * from "./Temu.vue?vue&type=script&lang=js"
import style0 from "./Temu.vue?vue&type=style&index=0&id=6a313a7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a313a7f",
  null
  
)

export default component.exports